import React from 'react';
import { useAppContext } from '../../context/AppContext';
import { Users, BookOpen, Zap, Heart, Coffee, Home, Shield, ArrowRight } from 'lucide-react';

const WorkingInExcessDPage = () => {
    const { setContactFormOpen } = useAppContext();

    const testimonials = [
        {
            name: "Rahul Sharma",
            position: "Software Engineer",
            testimonial: "I joined EXCESSD as a fresh graduate through their internship program. The mentorship and hands-on experience I received helped me grow tremendously. Working on cutting-edge projects with global clients has been an incredible learning experience.",
            image: "/api/placeholder/80/80"
        },
        {
            name: "Priya Patel",
            position: "Technical Lead",
            testimonial: "I've been with EXCESSD for 3 years now, and what attracts me most is the team spirit and collaborative culture. The company provides excellent opportunities for career growth and technical skill development. The flexibility and work-life balance are outstanding.",
            image: "/api/placeholder/80/80"
        },
        {
            name: "Arjun Kumar",
            position: "Senior DevOps Engineer",
            testimonial: "EXCESSD gave me the opportunity to work on diverse projects spanning multiple technologies. The company's commitment to innovation and quality has helped me evolve as an engineer. The supportive environment makes it a great place to build your career.",
            image: "/api/placeholder/80/80"
        }
    ];

    return (
        <div className="flex flex-col">
            {/* Hero Section */}
            <section className="relative bg-gradient-to-r from-purple-900 via-blue-800 to-indigo-700 text-white py-20 md:py-32 overflow-hidden">
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute inset-0" style={{
                        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                    }}></div>
                </div>

                <div className="container mx-auto px-4 relative">
                    <div className="max-w-4xl">
                        <div className="mb-6">
                            {/* <span className="inline-block bg-yellow-400 text-black px-4 py-2 rounded-md text-sm font-bold uppercase tracking-wide">
                                Working in ExcessD
                            </span> */}
                        </div>
                        <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
                            Join Our Journey
                        </h1>
                        <p className="text-xl md:text-2xl mb-8 leading-relaxed opacity-90">
                            Innovate, Build and Grow with EXCESSD
                        </p>

                        <p className="text-lg mb-12 leading-relaxed opacity-80">
                            We believe in creating an environment where innovation thrives, people grow and excellence is achieved through collaboration and continuous learning
                        </p>

                        <div className="flex flex-col sm:flex-row gap-4">
                            {/* <button
                                onClick={() => setContactFormOpen(true)}
                                className="bg-yellow-400 text-black font-bold py-4 px-8 rounded-md hover:bg-yellow-300 transition-colors inline-flex items-center justify-center group"
                            >
                                JOIN OUR TEAM
                                <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform" />
                            </button> */}
                            {/* <button className="border-2 border-white text-white font-bold py-4 px-8 rounded-md hover:bg-white hover:text-purple-900 transition-colors">
                                View Open Positions
                            </button> */}
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Join Us Section */}
            <section className="py-20">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl md:text-4xl font-bold mb-6">Why Join Us?</h2>
                        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                            At EXCESSD, we create an environment where talented individuals can grow, innovate, and make a meaningful impact on Global Technology.
                        </p>
                    </div>

                    <div className="mb-16">
                        <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-8 rounded-xl text-center">
                            <div className="text-6xl mb-4">🎯</div>
                            <h3 className="text-2xl font-bold mb-4 text-red-600">Benefits Overview</h3>
                            <p className="text-gray-700 max-w-2xl mx-auto">
                                We offer comprehensive benefits designed to support your professional growth, personal well-being, and work-life balance.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Personal Development Section */}
            <section className="py-20 bg-gray-50">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl md:text-4xl font-bold mb-6">Personal Development</h2>
                        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                            At EXCESSD, we value technical competence and knowledge sharing. As a constantly growing company with strong experience, we are committed to provide opportunities for your personal and professional development.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div className="bg-white p-8 rounded-xl shadow-sm text-center">
                            <div className="bg-blue-100 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                                <BookOpen className="text-blue-600" size={24} />
                            </div>
                            <h3 className="text-xl font-bold mb-4 text-red-600">Learning by Doing</h3>
                            <p className="text-gray-700">Featuring cutting-edge technologies, are crucial in supporting the development of professional knowledge and skills among our employees.</p>
                        </div>

                        <div className="bg-white p-8 rounded-xl shadow-sm text-center">
                            <div className="bg-green-100 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                                <Users className="text-green-600" size={24} />
                            </div>
                            <h3 className="text-xl font-bold mb-4 text-red-600">Learning through Feedback</h3>
                            <p className="text-gray-700">We believe that we learn best from each other, whether through a mentoring process, regular feedback or formal evaluations.</p>
                        </div>

                        <div className="bg-white p-8 rounded-xl shadow-sm text-center">
                            <div className="bg-purple-100 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                                <Zap className="text-purple-600" size={24} />
                            </div>
                            <h3 className="text-xl font-bold mb-4 text-red-600">Personal Motivation</h3>
                            <p className="text-gray-700">Our managers and HR business partners are committed to linking personal aspirations with business needs to create the best solution that delivers results for everyone.</p>
                        </div>

                        <div className="bg-white p-8 rounded-xl shadow-sm text-center">
                            <div className="bg-orange-100 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                                <BookOpen className="text-orange-600" size={24} />
                            </div>
                            <h3 className="text-xl font-bold mb-4 text-red-600">Learning through Courses</h3>
                            <p className="text-gray-700">We offer a wide range of technical and soft skill courses, both on-site and online, to help our employees stay ahead of the curve.</p>
                        </div>

                        <div className="bg-white p-8 rounded-xl shadow-sm text-center">
                            <div className="bg-red-100 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                                <span className="text-2xl">✈️</span>
                            </div>
                            <h3 className="text-xl font-bold mb-4 text-red-600">Global Exposure</h3>
                            <p className="text-gray-700">Our work connects us with clients all over the world, providing opportunities for international collaboration and cultural exchange.</p>
                        </div>

                        <div className="bg-white p-8 rounded-xl shadow-sm text-center">
                            <div className="bg-teal-100 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                                <span className="text-2xl">📚</span>
                            </div>
                            <h3 className="text-xl font-bold mb-4 text-red-600">Knowledge Sharing</h3>
                            <p className="text-gray-700">We provide opportunities for knowledge sharing sessions, e-learning platforms, and access to extensive learning resources.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Team Spirit Section */}
            <section className="py-20">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl md:text-4xl font-bold mb-6">Team Spirit</h2>
                        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                            Team spirit is an essential component of ensuring that we are all working towards the same goals. We cultivate this spirit by creating an atmosphere of trust and openness.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-3 gap-8">
                        <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-xl text-center">
                            <div className="text-4xl mb-4">🏃‍♂️</div>
                            <h3 className="text-xl font-bold mb-4 text-red-600">Sport Engagement</h3>
                            <p className="text-gray-700">Organized team sports, participation in sport tournaments and events, promoting health and team bonding.</p>
                        </div>

                        <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-xl text-center">
                            <div className="text-4xl mb-4">🎯</div>
                            <h3 className="text-xl font-bold mb-4 text-red-600">Team Buildings</h3>
                            <p className="text-gray-700">We encourage teams to create and participate in team-building activities that align with their interests and dynamics.</p>
                        </div>

                        <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-8 rounded-xl text-center">
                            <div className="text-4xl mb-4">🎉</div>
                            <h3 className="text-xl font-bold mb-4 text-red-600">Social Activities</h3>
                            <p className="text-gray-700">Social events, celebration parties, cultural activities, and team gatherings that bring everyone together.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Working Conditions Section */}
            <section className="py-20 bg-gray-50">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl md:text-4xl font-bold mb-6">Pleasant Working Conditions</h2>
                        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                            We recognize that creating a pleasant work environment is a significant contributor to employee satisfaction, engagement, and work motivation.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
                        <div className="bg-white p-6 rounded-lg shadow-sm text-center">
                            <div className="bg-blue-100 p-3 rounded-full w-12 h-12 mx-auto mb-4 flex items-center justify-center">
                                <span className="text-xl">⏰</span>
                            </div>
                            <h3 className="text-lg font-bold mb-3 text-red-600">Flexible Hours</h3>
                            <p className="text-gray-700 text-sm">We believe in flexible hours</p>
                        </div>

                        {/* <div className="bg-white p-6 rounded-lg shadow-sm text-center">
                            <div className="bg-green-100 p-3 rounded-full w-12 h-12 mx-auto mb-4 flex items-center justify-center">
                                <Coffee className="text-green-600" size={20} />
                            </div>
                            <h3 className="text-lg font-bold mb-3 text-red-600">Great Workspace</h3>
                            <p className="text-gray-700 text-sm">Comfortable office space with great coffee and tea</p>
                        </div> */}

                        <div className="bg-white p-6 rounded-lg shadow-sm text-center">
                            <div className="bg-purple-100 p-3 rounded-full w-12 h-12 mx-auto mb-4 flex items-center justify-center">
                                <Home className="text-purple-600" size={20} />
                            </div>
                            <h3 className="text-lg font-bold mb-3 text-red-600">Remote Work</h3>
                            <p className="text-gray-700 text-sm">Flexibility to work from home when needed</p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-sm text-center">
                            <div className="bg-orange-100 p-3 rounded-full w-12 h-12 mx-auto mb-4 flex items-center justify-center">
                                <Heart className="text-orange-600" size={20} />
                            </div>
                            <h3 className="text-lg font-bold mb-3 text-red-600">Personal Care</h3>
                            <p className="text-gray-700 text-sm">We value employee well-being and family support</p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-sm text-center">
    <div className="bg-orange-100 p-3 rounded-full w-12 h-12 mx-auto mb-4 flex items-center justify-center">
        <Shield className="text-orange-600" size={20} />
    </div>
    <h3 className="text-lg font-bold mb-3 text-red-600">Life Insurance</h3>
    <p className="text-gray-700 text-sm">Private health insurance</p>
</div>
                    </div>

                    {/* <div className="grid md:grid-cols-3 gap-8">
                        <div className="bg-white p-6 rounded-lg shadow-sm">
                            <div className="flex items-center mb-4">
                                <div className="bg-red-100 p-2 rounded-full mr-3">
                                    <Shield className="text-red-600" size={20} />
                                </div>
                                <h3 className="text-lg font-bold text-red-600">Health Care</h3>
                            </div>
                            <p className="text-gray-700">Private health insurance</p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-sm">
                            <div className="flex items-center mb-4">
                                <div className="bg-blue-100 p-2 rounded-full mr-3">
                                    <Users className="text-blue-600" size={20} />
                                </div>
                                <h3 className="text-lg font-bold text-red-600">Family Care</h3>
                            </div>
                            <p className="text-gray-700">Support for newborns, family events, and children's programs</p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-sm">
                            <div className="flex items-center mb-4">
                                <div className="bg-green-100 p-2 rounded-full mr-3">
                                    <span className="text-lg">💰</span>
                                </div>
                                <h3 className="text-lg font-bold text-red-600">Discounts</h3>
                            </div>
                            <p className="text-gray-700">Access to discounts for various services, shopping, fitness, and banking</p>
                        </div>
                    </div> */}
                </div>
            </section>

            {/* Testimonials Section */}
            {/* <section className="py-20">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl md:text-4xl font-bold mb-6">What Our Team Says</h2>
                        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                            Hear from our team members about their experience working at EXCESSD and how it has shaped their careers.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-3 gap-8">
                        {testimonials.map((testimonial, index) => (
                            <div key={index} className="bg-white p-8 rounded-xl shadow-lg">
                                <div className="flex items-center mb-6">
                                    <div className="w-16 h-16 bg-gray-200 rounded-full mr-4 flex items-center justify-center">
                                        <span className="text-gray-500 font-bold text-lg">{testimonial.name.split(' ').map(n => n[0]).join('')}</span>
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-bold">{testimonial.name}</h3>
                                        <p className="text-blue-600 text-sm">{testimonial.position}</p>
                                    </div>
                                </div>
                                <p className="text-gray-700 italic">"{testimonial.testimonial}"</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}

            {/* CTA Section */}
            <section className="py-20 bg-gradient-to-r from-purple-900 to-blue-800 text-white">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Join Our Team?</h2>
                    <p className="text-xl mb-8 opacity-90 max-w-2xl mx-auto">
                        Be part of our journey in building exceptional technology solutions while growing your career in a supportive and innovative environment.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <button
                            onClick={() => setContactFormOpen(true)}
                            className="bg-yellow-400 text-black font-bold py-4 px-8 rounded-md hover:bg-yellow-300 transition-colors inline-flex items-center justify-center group"
                        >
                            APPLY NOW
                            {/* <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform" /> */}
                        </button>
                        {/* <button className="border-2 border-white text-white font-bold py-4 px-8 rounded-md hover:bg-white hover:text-purple-900 transition-colors">
                            View Open Positions
                        </button> */}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default WorkingInExcessDPage;